import { MDBCol, MDBRow } from 'mdbreact'
import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import { CheckboxToggle } from 'react-rainbow-components';
import { Link, useHistory } from 'react-router-dom';
import CustomLoader from '../shared/Customloader';
import { customStyles } from '../shared/datatables/styles';
import ShowNotification from '../shared/Notification';
import { RequestInit, RequestInitWithBody } from '../shared/RequestInit';

export interface propsToEdit {
    planning_Id: number,
    emissions_Id: number,
    emission: string,
    description: string,
    jour: string,
    heure_debut: string,
    heure_Fin: string,
    nom: string,
    active: 0 | 1,
    livecam: 0 | 1,
    emission_banniere:string,
    planning_active: 0 | 1
}


const MonPlanning: React.FC = () => {
    const [emissions, setEmissions] = useState([])
    const [pending, setPending] = useState(false)
    const [updated, setUpdated] = useState(false)
    const [filteredData, setFilteredData] = useState([])
    const history = useHistory<any>();

    const fetchEmissions = async () => {
        await fetch('https://admin.radioemotion.be/api/emission/getuseremissions', RequestInit as RequestInit)
            .then(response => response.json())
            .then(response => {
                if (response.response === true) {
                    console.log(response)
                    setEmissions(response.data)
                    setFilteredData(response.data)
                    setPending(false)
                }
            })
            .catch(err => {
                console.log(err)
            })
    }
    useEffect(() => {
        setPending(true);
        fetchEmissions();
    }, [])


    const changeActive = (Id: number, state: number, type: 'livecam' | 'isActive') => {
        const updateLivecam = async () => {
            await fetch(`${type === 'isActive' ? 'https://admin.radioemotion.be/api/emission/updateactive' : 'https://admin.radioemotion.be/api/emission/updatelivecam'}`, RequestInitWithBody({ body: { Id: Id, state: state === 1 ? 0 : 1 }, type: 'POST' }) as RequestInit)
                .then(response => response.json())
                .then(response => {
                    if (response.response === true) {
                        setEmissions(response.data)
                        fetchEmissions()
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
        updateLivecam();
    }
    return (
        <div>
            { updated === true || history.location.state && history.location.state.passed === true ?
            <ShowNotification
                icon="check"
                iconClassName="success-dark-text"
                bodyClassName="px-5 font-weight-bold text-white success-color-dark"
                autohide={5000}
                title=""
                message={history.location.state.message}
                text="maintenant"
            /> : null}
            <MDBRow>
                <MDBCol md="9" className="offset-2" >
                    <DataTable
                        pointerOnHover={true}
                        data={filteredData}
                        subHeader={true}
                        customStyles={customStyles}
                        progressPending={pending}
                        progressComponent={<CustomLoader />}
                        pagination={true}
                        className="datatable"
                        columns={
                            [
                                {
                                    name: `Emission`,
                                    selector: `Emission`,
                                    sortable: true,
                                    width: '20%',
                                    cell: (row: any) => <><Link to={{ pathname: `/emission/updateemission`, state: row }} className="font-size-0dot65vw">{row.emission}</Link></>

                                },
                                {
                                    name: `Animateur`,
                                    selector: `Nom`,
                                    sortable: true,
                                    width: '10',
                                    cell: row => <><Link to={{ pathname: `/emission/updateemission`, state: row }} className="font-size-0dot65vw">{row.nom}</Link></>

                                },
                                {
                                    name: `Jour`,
                                    selector: `Jour`,
                                    sortable: true,
                                    width: '10',
                                    cell: row => <><Link to={{ pathname: `/emission/updateemission`, state: row }} className="font-size-0dot65vw">{row.jour}</Link></>

                                },
                                {
                                    name: `debut`,
                                    selector: `Heure_debut`,
                                    sortable: true,
                                    width: '12%',
                                    cell: row => <><Link to={{ pathname: `/emission/updateemission`, state: row }} className="font-size-0dot65vw">{row.heure_debut}</Link></>

                                },
                                {
                                    name: `Fin`,
                                    selector: `Heure_Fin`,
                                    sortable: true,
                                    width: '12%',
                                    cell: row => <><Link to={{ pathname: `/emission/updateemission`, state: row }} className="font-size-0dot65vw">{row.heure_Fin}</Link></>

                                },
                                {
                                    name: `Livecam`,
                                    selector: `Livecam`,
                                    sortable: true,
                                    width: '13%',
                                    cell: row => <>
                                        <CheckboxToggle
                                            id="checkbox-toggle-component-1"
                                            label={row.livecam === 1 ? 'active' : 'pas active'}
                                            value={row.livecam === 1 ? true : false}
                                            onChange={(event: React.ChangeEvent<HTMLElement>) => changeActive(row.planning_Id, row.livecam, 'livecam')}
                                        /></>

                                },
                                {
                                    name: 'Active',
                                    selector: 'Active',
                                    sortable: true,
                                    width: '13',
                                    cell: row => <>
                                        <CheckboxToggle
                                            id="checkbox-toggle-component-1"
                                            label={row.active === 1 ? 'active' : 'pas active'}
                                            value={row.active === 1 ? true : false}
                                            onChange={(event: React.ChangeEvent<HTMLElement>) => changeActive(row.planning_Id, row.active, 'isActive')}
                                        /></>
                                }]}></DataTable>

                </MDBCol>
            </MDBRow>
        </div>
    )
}

export default MonPlanning
